module.exports = __webpack_public_path__ + "static/media/csv.c0777cc4.png";